import { css } from "@emotion/core";
import { Button as WebUIButton } from "@ef-global/web-ui-react/lib/components/Button";
import React, { useState } from "react";
import { scroll } from "~components/utils/scroll";
import { IStoryblokLink } from "~/src/interfaces/storyblock";
import Link from "~components/utils/link";
import Icon from "~components/custom/icon";
import Components from "~components/components";

interface IButtonProps {
  text: string;
  primary?: boolean;
  cta?: boolean;
  square?: boolean;
  small?: boolean;
  scroll_to?: string;
  id?: string;
  link?: IStoryblokLink;
  background_color?: any;
  border_color?: any;
  text_color?: any;
  open_in_a_new_tab?: boolean;
  action?: any;
  icon?: any;
  icon_position?: any;
  story?: any;
}

const Button = (props: IButtonProps) => {
  const {
    action,
    text,
    primary,
    cta,
    small,
    square,
    scroll_to = "",
    id,
    link,
    background_color,
    border_color,
    open_in_a_new_tab,
    story,
    text_color,
    icon,
    icon_position,
  } = props;

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const buttonStyle = css`
    border: ${
      border_color?.color
        ? `${border_color?.color} solid 1px !important`
        : "inherit"
    };
    background-color: ${
      background_color?.color
        ? `${background_color?.color} !important`
        : "inherit"
    };
    color: ${text_color?.color ? `${text_color?.color} !important` : "inherit"};
    .ef-icon__container {
      ${
        icon &&
        icon_position == "LEFT" &&
        "margin-right: " + (props.small ? "14px" : "18px") + ";"
      }
      ${
        icon &&
        icon_position == "RIGHT" &&
        "margin-left: " + (props.small ? "14px" : "18px") + ";"
      }
      transform: translateY(${props.small ? "2px" : "3px"});
      > svg {
        font-size: ${props.small ? "12px" : "16px"};
      }
    }
  `;

  const renderButton = () => (
    <WebUIButton
      {...(primary ? { primary: true } : { secondary: true })}
      cta={cta}
      small={small}
      square={square}
      onClick={() => (scroll_to ? scroll(scroll_to) : handleOpen())}
      id={id}
      className="ef-button-pointer-events-none"
      style={{ height: "fit-content" }}
      css={[buttonStyle]}
    >
      {icon && icon_position == "LEFT" && (
        <Icon
          // @ts-ignore
          icon={icon}
          icon_color={text_color?.color ?? "#000"}
          icon_bg_color="transparent"
          icon_size="s"
        />
      )}
      {text}
      {icon && icon_position == "RIGHT" && (
        <Icon
          // @ts-ignore
          icon={icon}
          icon_color={text_color?.color ?? "#000"}
          icon_bg_color="transparent"
          icon_size="s"
        />
      )}
    </WebUIButton>
  );

  const renderLink = () => (
    <Link
      className={
        `ef-button` +
        `${primary ? " -primary" : " -secondary"}` +
        `${small ? " -small" : ""}` +
        `${square ? " -square" : ""}`
      }
      storyblokLink={link}
      id={id}
      openInANewTab={open_in_a_new_tab ?? false}
      onClick={handleOpen}
      style={{ height: "fit-content" }}
      css={[buttonStyle]}
    >
      <span className="ef-button__content">
        {icon && icon_position == "LEFT" && (
          <Icon
            // @ts-ignore
            icon={icon}
            icon_color={text_color?.color ?? "#000"}
            icon_bg_color="transparent"
            icon_size="s"
          />
        )}
        {text}
        {icon && icon_position == "RIGHT" && (
          <Icon
            // @ts-ignore
            icon={icon}
            icon_color={text_color?.color ?? "#000"}
            icon_bg_color="transparent"
            icon_size="s"
          />
        )}
      </span>
    </Link>
  );

  return (
    <>
      {action && action[0]
        ? Components({ ...action[0], open, handleOpen, handleClose }, story)
        : null}
      {link?.id || link?.url ? renderLink() : renderButton()}
    </>
  );
};

export default Button;
